window.global ||= window

import('./bootstrap');
import 'jquery-ui/dist/jquery-ui.min'
import * as globals from "./components/functions/globals";
import {updateWalletInformation} from "@/utils/dom";
import {refreshTab} from './components/tabs/refresh_tab'
import {reloadTable} from "@resources/theme/js/components/datatables/getters";
import {loadLanguage, i18n} from "@/plugins/i18n";
$(document).ready(async () => await loadLanguage())
$('body').on('click', '.prevent-from-redirect', e => {
    e.preventDefault();
});

$('body').on('click', '.sign-file-dropdown-list', e => {
    e.preventDefault();

    const dataset = e.target.dataset;
    let checkboxes = $('body').find('input[name="action_ids[]"]:checked');
    let additionalData = JSON.parse(dataset.additionalData);
    let checkedIds = []

    for (var i = 0; i < checkboxes.length; i++) {
        checkedIds.push(checkboxes[i].value);
    }
    $eventEmit('sign_files_sign', {
        mediaType: additionalData.mediaType,
        mediaDisk: additionalData.mediaDisk,
        userId: additionalData.userId,
        table_id: additionalData.table_id,
        itemId: checkedIds

    })
});
$('body').on('click', '.single-file-sign', e => {
    e.preventDefault();

    const dataset = e.target.dataset;
    const signFilesForm = document.querySelector('custom-sign-file-component');
    let additionalData = JSON.parse(dataset.additionalData);

    let checkedIds = [additionalData.itemId]
    if (signFilesForm) {
        let vueInstance = signFilesForm.getVueInstance();
        vueInstance.setParameters(additionalData.userId, additionalData.estateId, checkedIds, additionalData.mediaType, additionalData.mediaDisk,additionalData.table_id);
        setTimeout(function () {
            vueInstance.showModal();
        }, 200);
    }
});

// Wczytujemy różnego rodzaju elementy, jeśli to wymagane
$('body').on('shown.bs.modal shown.bs.tab tab_loader:success shown.bs.collapse custom_tab:show custom_modal:after_open', e => {
    const namespace = e.hasOwnProperty('namespace') ? `.${e.namespace}` : ''
    const type = e.type + namespace

    switch (type) {
        case 'shown.bs.tab':
        case 'shown.bs.modal':
        case 'shown.bs.collapse':
            // globals.initDatatables();
            if (e.target.classList.contains('script_runner_initialized')) {
                return false
            }
            break;
        case 'tab_loader:success':
            if (e.detail.tab.classList.contains('script_runner_initialized')) {
                return false
            }
            break;
        case 'custom_tab:show':
            if (e.detail.link.classList.contains('script_runner_initialized')) {
                return false
            }
            break;
        case 'custom_modal:after_open':
            if (e.detail.button.classList.contains('script_runner_initialized')) {
                return false
            }

            break;
        default:
            break;
    }

    const scriptRunnerPromise = new Promise((resolve, reject) => {
        globals.init();
        globals.initDatatables();
        globals.initDropzone();
        CharCounter.init();
        Addresses.initGoogleMapsField();

        switch (type) {
            case 'shown.bs.tab':
            case 'shown.bs.modal':
            case 'shown.bs.collapse':
                e.target.classList.add('script_runner_initialized')
                break;
            case 'tab_loader:success':
                e.detail.tab.classList.add('script_runner_initialized');
                break;
            case 'custom_tab:show':
                e.detail.link.classList.add('script_runner_initialized');
                break;
            case 'custom_modal:after_open':
                e.detail.button.classList.add('script_runner_initialized');
                break;
            default:
                break;
        }

        resolve(true);
    });

    scriptRunnerPromise.then(value => {
        if (value) {
            const event = new CustomEvent('scripts_initialized', {
                detail: {
                    type: type,
                    target: e.target,
                    relatedTarget: e.relatedTarget,
                    event_detail: e.detail
                }
            });

            document.body.dispatchEvent(event);
        }
    });
});
// Moduł tłumaczeń
import('./components/translator/translator');

// Globalne funkcje
import('./components/functions/functions');

// Scrollbar float
import('./components/tableFloatScrollbar/table_float_scrollbar');

// Toasts
import('./components/toasts/toast');

// Custom Tabs
import('./components/tabs/tab_loader');
import('./components/tabs/custom_tabs');

// Wczytuje walidację przy pomocy AJAX z możliwością wpięcia się do listenerów validation:success i validation:failed
import('./components/validation/validation_helper');
import('./components/validation/validation');

// Dropzone
import('./components/dropzone/dropzone');

// Draggable Scroll
import('./components/draggableScroll/draggable_scroll');

// Datatables
import './components/datatables/datatables'

// Confirmation
import('./components/confirmation_element/confirmation_element');
import('./components/confirmation_element/confirmation_modal');

// Szablony
import('./components/templates/templates');

// Moduł aktualizowania częściowo modelu
import('./components/data_model_updater/data-model-updater');

// Generowanie szablonu z możliwością zmiany na nim elementów
import('./components/template_generator/template_generator');

// Licznik znaków polu
import('./components/char_counter/char_counter');

//Moduł dokumentów kosztowych
import('./components/modules/cost_documents/cost_documents');

import('./components/modules/estates/estates');

// Użytkownicy
import('./components/modules/users');

//Moduł najemców
import('./components/modules/tenants/tenants');
import('./components/modules/division');

//websites
import('./components/modules/websites/websites');

// Dodatkowe mniejsze skrypty
import('./components/functions/custom');

//Moduł właściciela
import('./components/modules/owners/owners');

//Moduł aktywności
import('./components/modules/activity');

// Sidebar
//import('./components/layouts/sidebar');

// IMask
import('./components/imask/imask');

// Flatpickr
import('./components/flatpickr/flatpickr');

// Addresses
import('./components/addresses/addresses');

// Auth
import('./components/modules/create_help_messages');

// Modal
import('./components/modal/modal');

// CRUD dla płatności masowych
import('./components/mass_payments/massPaymentsCrud');

import('./components/modules/finances/finances');

// Raporty
import('./components/reports/index');

import('./components/modules/users_and_permissions/users_and_permissions')

import('./components/modules/documents')

// należności przyszłe za zarządzanie
import('./components/modules/owners/liability_management')

// Wsparcie PWA (TWA)
document.addEventListener('DOMContentLoaded', function () {
    //globals.initTooltips();
    //globals.initPopovers();

    if (location.href.includes('?twa=true')) {
        localStorage.twa = 'true';
    }

    if (localStorage.getItem('twa') == 'true') {
        document.querySelectorAll('.d-standalone').forEach(function (item) {
            item.classList.add('d-block');
        });
    }
});

// if ('serviceWorker' in navigator) {
//     window.addEventListener('load', function () {
//         navigator.serviceWorker.register(`${window.location.protocol}//${window.location.hostname}/service-worker.js`).then(function (registration) {
//             // Registration was successful
//             console.log('ServiceWorker registration successful with scope: ', registration.scope);
//         }, function (err) {
//             // registration failed :(
//             console.log('ServiceWorker registration failed: ', err);
//         });
//     });
// }

// Ustawia wybrany tab (jeśli istnieje), jeśli w linku jest hash (#)
$('body').on('click', '[data-toggle="tab"]', e => {
    const urlParams = new URLSearchParams(window.location.search);
    const currentTarget = e.currentTarget;
    if (currentTarget.getAttribute('href').substr(1) === 'show-messages') {

    }
    const promise = new Promise(resolve => {
        if (currentTarget.classList.contains('accent')) {
            if (!urlParams.has('show_tab')) {
                const mainTab = currentTarget.closest('.tab-pane');
                if (mainTab) {
                    urlParams.set('show_tab', mainTab.getAttribute('id'));
                }
            }

            urlParams.set('show_inner_tab', currentTarget.getAttribute('href').substr(1));
            resolve(true)
        } else {
            urlParams.set('show_tab', currentTarget.getAttribute('href').substr(1));
            setTimeout(() => {
                const hrefInnerTab = document.querySelector(`[id="${currentTarget.getAttribute('href').substr(1)}"]`).querySelector('.nav-link.accent');
                if (hrefInnerTab) {
                    urlParams.set('show_inner_tab', urlParams.has('show_inner_tab') ? urlParams.get('show_inner_tab') : hrefInnerTab.getAttribute('href').substr(1));
                } else {
                    urlParams.delete('show_inner_tab');
                }

                resolve(true)
            }, 1000)
        }
    });

    promise.then(value => {
        if (value) {
            const modal = currentTarget.closest('.modal');
            if (modal) {
                urlParams.set('modal', modal.id);
            }

            const updateUrl = window.location.pathname + '?' + urlParams.toString() + window.location.hash;
            history.pushState(null, '', updateUrl);
            const event = new CustomEvent('tab_changes', {data: updateUrl})
            document.dispatchEvent(event)
        }
    })
});
// Back to top
$('body').on('click', 'a[href^="#back-to-table-top-"]', () => {
    document.getElementById('main').scrollTo({
        top: 0,
        behavior: "smooth"
    });
})

$(window).on('load', () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('show_tab')) {
        if (urlParams.has('modal')) {
            const modalButton = document.querySelector(`[data-toggle="modal"][data-target="#${urlParams.get('modal')}"]`);
            if (modalButton) {
                modalButton.click();
            }
        }

        const href = document.querySelector(`[data-toggle="tab"]:not(.active)[href="#${urlParams.get('show_tab')}"]`);
        if (href) {
            href.click();
        }

        $(`[id="${urlParams.get('show_tab')}"]`).on('shown.bs.tab', e => {
            if (!urlParams.has('show_inner_tab')) {
                e.target.click();
            } else if (urlParams.has('show_inner_tab')) {
                const hrefInnerTab = document.querySelector(`[data-toggle="tab"]:not(.active)[href="#${urlParams.get('show_inner_tab')}"]`);
                if (hrefInnerTab) {
                    hrefInnerTab.click();
                }

                const activeHrefInnerTab = document.querySelector(`[data-toggle="tab"].active[href="#${urlParams.get('show_inner_tab')}"]`);
                if (activeHrefInnerTab) {
                    const selectWallet = activeHrefInnerTab.closest('.select-wallet');
                    if (selectWallet) {
                        activeHrefInnerTab.classList.add('force-reload-wallet-tab');
                        selectWallet.click();
                    }
                }
            }

            $(`[id="${urlParams.get('show_tab')}"]`).unbind('shown.bs.tab')
        });
    } else if (!urlParams.has('show_tab') && urlParams.has('show_inner_tab')) {
        if (urlParams.has('modal')) {
            const modalButton = document.querySelector(`[data-toggle="modal"][data-target="#${urlParams.get('modal')}"]`);
            if (modalButton) {
                modalButton.click();
            }
        }

        const href = document.querySelector(`[data-toggle="tab"]:not(.active)[href="#${urlParams.get('show_inner_tab')}"]`);
        if (href) {
            href.click();
        }
    }
});

$('body').on('show.bs.modal', e => {
    const button = e.relatedTarget;
    const urlParams = new URLSearchParams(window.location.search);

    // Jeśli button ma data-tab, to ustawia go tylko, jeśli jakiś konkretny tab nie jest już zaznaczony do wyświetlenia
    if (button && button.dataset.hasOwnProperty('tab') && !urlParams.has('show_tab')) {
        const tab = button.getAttribute('data-tab');
        let buttonTab = document.querySelector(`[href="${tab}"][data-toggle="tab"]`);

        if (buttonTab) {
            buttonTab.click();
        }
    }
});

$(document).ajaxError((event, request) => {
    if (request.status == 404 && request.responseJSON && request.responseJSON.message && !request.responseJSON.skip_notification) {
        Toast.message({
            message: request.responseJSON.message,
            type: 'error',
            closeButton: true
        });
    }

    if (request.status == 500 && request.responseJSON && request.responseJSON.message && !request.responseJSON.skip_notification) {
        Toast.message({
            message: request.responseJSON.message,
            type: request.responseJSON.type ? request.responseJSON.type : 'error',
            autoHide: request.responseJSON.auto_hide,
            closeButton: true,
            mode: {
                type: 'close'
            }
        });
    }

    if (request.status == 500 && request.responseJSON && request.responseJSON.toast && !request.responseJSON.skip_notification) {
        $eventEmit('notify', {
            message: request.responseJSON.toast.message ?? Translator.__('komunikat Wystąpił błąd. (ajax error)'),
            variant: request.responseJSON.toast.variant ?? 'error',
            autoHideDelay: request.responseJSON.toast.autoHideDelay ?? 2000
        })
    }

    if (request.status == 419) {
        Toast.message({
            message: Translator.__('Twoja sesja wygasła, za chwilę strona zostanie przeładowana, jeśli to konieczne, zaloguj się ponownie.'),
            type: 'error',
            closeButton: true
        });

        setTimeout(() => window.location.reload(), 5000)
    }
});

$(document).ajaxSuccess((event, request) => {
    if (request.status == 200 && request.responseJSON && (request.responseJSON.message || request.responseJSON.toast) && !request.responseJSON.skip_notification) {
        if (request.responseJSON.toast) {
            $eventEmit('notify', request.responseJSON.toast)
        } else {
            Toast.message({
                message: request.responseJSON.message?.text ?? request.responseJSON.toast.message,
                type: request.responseJSON.message?.type ?? request.responseJSON.toast.variant,
                closeButton: true
            });
        }
    }

    if (request.status == 200 && request.responseJSON && request.responseJSON.table_id) {
        setTimeout(() => {
            reloadTable(request.responseJSON.table_id)
        }, 1000)
    }

    if (request.status == 200 && request.responseJSON && request.responseJSON.reload) {
        setTimeout(() => {
            window.location.reload(true)
        }, 1000)
    }

    if (request.status == 200 && request.responseJSON && request.responseJSON.dispatch_event) {
        setTimeout(() => {
            window.dispatchEvent(new Event(request.responseJSON.dispatch_event));
        }, request.responseJSON.dispatch_event_timeout ?? 1000)
    }

    if (request.status == 250 && request.responseJSON && request.responseJSON.message && !request.responseJSON.skip_notification) {
        Toast.message({
            message: request.responseJSON.message,
            type: 'warning',
            closeButton: true
        });
    }

    if (request.responseJSON && request.responseJSON.hasOwnProperty('reload_object')) {
        window.dispatchEvent(new CustomEvent(`update-${request.responseJSON.table_type}-show`, { detail: request.responseJSON.object_id }))
    }

    if (request.responseJSON && request.responseJSON.hasOwnProperty('deposit_to_pay')) {
        updateWalletInformation(request.responseJSON)
    }

    if (request.responseJSON && request.responseJSON.hasOwnProperty('reload_tab')) {
        refreshTab(request.responseJSON.reload_tab)
    }
});

$(document).ajaxComplete((event, request) => {
    if (request.responseJSON && request.responseJSON.additional_response_messages && !request.responseJSON.skip_notification) {
        request.responseJSON.additional_response_messages.forEach(message => {
            Toast.message({
                message: message.text,
                type: message.type,
                closeButton: true
            });
        });
    }

    if (request.responseJSON && request.responseJSON.redirect_url) {
        window.location.href = request.responseJSON.redirect_url;
    }
    if (request.responseJSON && request.responseJSON.reload_instance) {
        window.location.reload()
    }
});

// URL hash przy logowaniu
if (route().current('login')) {
    if (window.location.hash) {
        const hash = window.location.hash;
        const form = document.querySelector('.auth-wrapper form');

        if (form) {
            const hashField = form.querySelector('[name="_hash"][type="hidden"]');

            if (hashField) {
                hashField.value = hash;
            } else {
                form.insertAdjacentHTML('afterbegin', `<input name="_hash" type="hidden" value="${hash}" />`);
            }
        }
    }
}

/*
    To jest konektor routingu osadzonego poza instancją Vue.
    <a href="#"  data-route="{'name':'estates.show','params':{'estateId':85}}">Złota , Kraków</a>
 */
document.addEventListener(`click`, (e) => {
    const anchor = e.target.closest('a[data-route]')
    if (anchor) {
        const route = anchor.getAttribute('data-route')
        if (route) {
            const vueInstance = document.querySelector('#app').__vue__
            vueInstance.$router.push(JSON.parse(route)).catch(()=>{})
            e.preventDefault()
        }
    }
})
// Odświeżanie Jquery DataTables osadzonych w vue
window.addEventListener('data-table-reload', (e) => {
    reloadTable(e.detail.tableId)
})

const progressBar = document.body.querySelector('.installing-container .progress-bar')
const fetchData = () => {
    $.ajax({
        url: window.location.href,
        type: 'GET',
        dataType: 'json',
        complete: (xhr) => {
            const data = xhr.responseJSON;
            if (!data) {
                progressBar.style.width = `100%`
                progressBar.setAttribute('aria-valuenow', 100)
                progressBar.innerText = i18n.t('tekst Instalacja zakończona, za chwilę nastąpi przekierowanie (instalacja instancji)')
                setTimeout(() => window.location.href = route('admin.index'), 3000)
            } else if (xhr.status === 200) {
                progressBar.style.width = `${data.percent_install_status}%`
                progressBar.setAttribute('aria-valuenow', data.percent_install_status)
                progressBar.innerText = data.status_label
            }
        }
    })
}

if (progressBar) {
    setInterval(() => fetchData(), 2000)
}
